import Vue from 'vue';
import Vuex from 'vuex';
import { LOAD_STATE } from '@/status';
// tslint:disable-next-line:no-var-requires
const { Snackbar } = require('buefy/dist/components/snackbar');

Vue.use(Vuex);

const errorOut = (message: string) => {
  Snackbar.open({
    type: 'is-warning',
    message,
    queue: true,
  });
};

export default new Vuex.Store({
  state: {
    expanded: 0,
    projects: [],
    arts: [],
    expierence: [],
    status: {
      projects: LOAD_STATE.EMPTY,
      expierence: LOAD_STATE.EMPTY,
      arts: LOAD_STATE.EMPTY,
    },
    contact: [
      { label: 'Github', data: 'github.com/LibertyBeta', rel: 'https://www.github.com/LibertyBeta' },
      { label: 'Phone', data: '(203)533-9005', rel: 'tel:203-533-9005' },
      { label: 'Email', data: 'rainer.paskiewcz@gmail.com', rel: 'mailto:rainer.paskiewicz@gmail.com' },
      { label: 'Twitter', data: '@LibertyBeta', rel: 'https://twitter.com/LibertyBeta' },
    ],

  },
  mutations: {
    setSection(state: any, { field, data }) {
      state[field] = data;
    },
    setStatus(state: any, { field, status }) {
      state.status[field] = status;
    },
  },
  actions: {
    async fetchProjects(context) {
      context.commit('setStatus', { field: 'projects', status: LOAD_STATE.LOADING });
      try {
        const ash = await fetch(`${process.env.VUE_APP_API_ROOT}projects.json`);
        const data = await ash.json();
        context.commit('setSection', { field: 'projects', data });
        context.commit('setStatus', { field: 'projects', status: LOAD_STATE.LOADED });
      } catch (e) {
        errorOut('Unable to fetch Project Data');
        context.commit('setStatus', { field: 'projects', status: LOAD_STATE.EMPTY });
      }
    },
    async fetchEmployment(context) {
      context.commit('setStatus', { field: 'expierence', status: LOAD_STATE.LOADING });
      try {
        const ash = await fetch(`${process.env.VUE_APP_API_ROOT}employment.json`);
        const data = await ash.json();
        context.commit('setSection', { field: 'expierence', data });
        context.commit('setStatus', { field: 'expierence', status: LOAD_STATE.LOADED });
      } catch (e) {
        errorOut('Unable to fetch Expiernce Data');
        context.commit('setStatus', { field: 'expierence', status: LOAD_STATE.EMPTY });
      }

    },
    async fetchArts(context) {
      context.commit('setStatus', { field: 'arts', status: LOAD_STATE.LOADING });
      try {
        const ash = await fetch(`${process.env.VUE_APP_API_ROOT}arts.json`);
        const data = await ash.json();
        context.commit('setSection', { field: 'arts', data });
        context.commit('setStatus', { field: 'arts', status: LOAD_STATE.LOADED });
      } catch (e) {
        errorOut('Unable to fetch Arts Data');
        context.commit('setStatus', { field: 'arts', status: LOAD_STATE.EMPTY });
      }

    },
  },
});
